export default {
  SESSION_EXPIRED: 'session expired',
  NETWORK_ONLINE: 'online',
  NETWORK_OFFLINE: 'offline',
  SITE_BELONGS_TO_ANOTHER_USER: 'site belongs to another user',
  REQUIRED_COOKIES_ARE_DELETED: 'required cookies are deleted',
};
